module.exports = __webpack_public_path__ + "media/images/icons/icon-flag-us-2bc4c34f2367a5339db716b7d6f3b567.svg";